// ─── Formatage date ─────────────────────────────────────────────────────────
export function formatDate(isoString, opts = {}) {
  const defaults = { day: 'numeric', month: 'short', year: 'numeric' };
  const d = new Date(isoString);
  if (!isoString || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('fr-FR', { ...defaults, ...opts });
}

export function formatDateTime(isoString) {
  const d = new Date(isoString);
  if (!isoString || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('fr-FR', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

// ─── Formatage montant FCFA ─────────────────────────────────────────────────
export function formatFCFA(amount) {
  if (!amount && amount !== 0) return '—';
  return amount.toLocaleString('fr-FR') + ' F';
}

// ─── Génération ID / QR ─────────────────────────────────────────────────────
export function generateId() {
  return 'COL-' + Date.now().toString().slice(-7);
}

export function generateQR(id) {
  return `QR-${id}`;
}

export function cleanColisCode(input) {
  if (!input) return '';
  let code = String(input).trim();

  // Si le code contient une URL ou un paramètre code=
  if (code.includes('code=')) {
    try {
      const urlToParse = code.match(/^https?:\/\//i) ? code : `https://${code}`;
      const urlObj = new URL(urlToParse);
      const parsedCode = urlObj.searchParams.get('code');
      if (parsedCode) code = parsedCode.trim();
    } catch {
      const match = code.match(/code=([^&]+)/);
      if (match && match[1]) code = decodeURIComponent(match[1]).trim();
    }
  } else if (code.match(/^https?:\/\//i) || code.includes('/suivi') || code.includes('/details')) {
    try {
      const parts = code.split('?')[0].split('/');
      const last = parts[parts.length - 1];
      if (last && last !== 'suivi' && last !== 'details') code = last.trim();
    } catch {
      // ignore
    }
  }

  // Nettoyer guillemets autour
  code = code.replace(/^["']|["']$/g, '').trim();

  // Supprimer préfixe QR- s'il est présent
  if (/^QR-+/i.test(code)) {
    code = code.replace(/^QR-+/i, '').trim();
  }

  // Normaliser le format sans tirets si nécessaire (ex: ZKI20260809ABC123 -> ZKI-20260809-ABC123)
  const normalized = code.replace(/[\s-]+/g, '').toUpperCase();
  const m = normalized.match(/^(ZKI|INT)(\d{8})([A-Z0-9]{6})$/);
  if (m) {
    return `${m[1]}-${m[2]}-${m[3]}`;
  }

  return code;
}

export function getParcelCode(colis) {
  if (!colis) return '';
  const raw = colis.id || colis.qr || '';
  return cleanColisCode(raw);
}

export function getParcelTrackUrl(colis) {
  const code = getParcelCode(colis);
  if (!code) return `${getAppBaseUrl()}/suivi`;
  return `${getAppBaseUrl()}/suivi?code=${encodeURIComponent(code)}`;
}

export function getAppBaseUrl() {
  if (typeof window === 'undefined') return '';
  const origin = window.location.origin;
  const pathname = window.location.pathname || '/';
  const firstSeg = pathname.split('/').filter(Boolean)[0] || '';
  const subpath = (firstSeg === 'express') ? '/express' : '';
  return `${origin}${subpath}`;
}

// ─── Styles réutilisables ───────────────────────────────────────────────────
export const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  border: '2px solid #e2e8f0',
  borderRadius: 12,
  fontSize: 14,
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  background: '#fafafa',
  color: '#1e293b',
  caretColor: '#1e293b',
  boxSizing: 'border-box',
};

export const labelStyle = {
  display: 'block',
  fontSize: 12,
  fontWeight: 700,
  color: '#475569',
  marginBottom: 6,
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
};

export const focusInput = (e) => {
  e.target.style.borderColor = '#4F46E5';
  e.target.style.boxShadow   = '0 0 0 3px rgba(79,70,229,0.1)';
  e.target.style.background  = '#fff';
};

export const blurInput = (e) => {
  e.target.style.borderColor = '#e2e8f0';
  e.target.style.boxShadow   = 'none';
  e.target.style.background  = '#fafafa';
};
